import api from './apiService'; // Authenticated Axios instance (attaches the Bearer token)

// Platform super admin endpoints. All of them require the SuperAdmin role on
// the API side; the page guard only hides the UI.
export const superAdminService = {
  getLabs: async () => {
    const response = await api.get('superadmin/labs');
    return response.data;
  },
  // Creates the lab, its Admin user and its subscription in one go.
  createLab: async ({ lab, admin, subscription }) => {
    const response = await api.post('Auth/Registration', {
      LabDetails: lab,
      UserModel: admin,
      Subscription: subscription
    });
    return response.data;
  },
  setSuspended: async (laboratoryId, isSuspended) => {
    const response = await api.put(`superadmin/labs/${laboratoryId}/suspension`, { isSuspended });
    return response.data;
  },
  setNotificationsAllowed: async (laboratoryId, isAllowed) => {
    const response = await api.put(`superadmin/labs/${laboratoryId}/notifications`, { isAllowed });
    return response.data;
  },
  setPushAllowed: async (laboratoryId, isAllowed) => {
    const response = await api.put(`superadmin/labs/${laboratoryId}/push`, { isAllowed });
    return response.data;
  },

  // Payment history + verification reuse the billing endpoints.
  getPayments: async (laboratoryId) => {
    const response = await api.get(`billing/laboratory/${laboratoryId}`);
    return response.data;
  },
  setPaymentStatus: async (billingId, status) => {
    const response = await api.put(`billing/${billingId}/status`, { status });
    return response.data;
  }
};
